import { FC } from 'react';
import { Select, SelectProps } from 'view/component/Select/Select';
import { SelectOption } from 'view/component/Select/SelectItem';


export enum VinculoServidor {
  NAO_ATIVO = 1,
  ATIVO = 2,
}


export const VinculoServidorSelect: FC<SelectProps> = props => {
  const opcoes: SelectOption[] = [
    { 'value': VinculoServidor.NAO_ATIVO, 'label': 'Não ativo'},
    { 'value': VinculoServidor.ATIVO, 'label': 'Ativo'},
  ]

  return <Select
    {...props}
    placeholder="Selecione uma situação"
    defaultValue={opcoes[1]}
    options={opcoes}
  />
}